import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/home.vue'),
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('../views/signin.vue'),
  },
  {
    path: '/docs/home',
    name: 'docs_home',
    component: () => import('../views/docs/home.vue'),
  },
  {
    path: '/docs/:file',
    name: 'docs_detail',
    component: () => import('../views/docs/detail.vue'),
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/terms.vue'),
  },
  {
    path: '/terms_jp',
    name: 'terms_jp',
    component: () => import('../views/terms_jp.vue'),
  },
  {
    path: '/buisinessdeal',
    name: 'buisinessdeal',
    component: () => import('../views/buisinessdeal.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy.vue'),
  },
  {path: '/account', redirect: {name: 'profile'}},
  {
    path: '/account/profile',
    name: 'profile',
    component: () => import('../views/account/profile.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/account/subscription',
    name: 'subscription',
    component: () => import('../views/account/subscription.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/sidebar/dashboard.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains',
    redirect: {name: 'brains_list'},
  },
  {
    path: '/brains/archives',
    name: 'archives',
    component: () => import('../views/sidebar/brains/archives.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains/list',
    name: 'brains_list',
    component: () => import('../views/sidebar/brains/list.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains/designer',
    name: 'brains_designer',
    component: () => import('../views/sidebar/brains/designer.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains/share',
    name: 'brains_share',
    component: () => import('../views/sidebar/brains/share.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains/public',
    name: 'brains_public',
    component: () => import('../views/sidebar/brains/public.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains/viewer/:brain_id',
    name: 'brains_viewer',
    component: () => import('../views/sidebar/brains/viewer.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/brains/detail/:brain_id',
    name: 'brain_detail',
    redirect: {name: 'brains_list'},
  },
  {path: '/notebooks', redirect: {name: 'notebooks_list'}},
  {
    path: '/notebooks/list',
    name: 'notebooks_list',
    component: () => import('../views/sidebar/notebooks/list.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/notebooks/new',
    name: 'notebooks_new',
    component: () => import('../views/sidebar/notebooks/new.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/notebooks/archives',
    name: 'notebooks_archives',
    component: () => import('../views/sidebar/notebooks/archives.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/notebooks/share',
    name: 'notebooks_share',
    component: () => import('../views/sidebar/notebooks/share.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/notebooks/public',
    name: 'notebooks_public',
    component: () => import('../views/sidebar/notebooks/public.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/notebooks/:notebook_id',
    name: 'notebooks_detail',
    component: () => import('../views/sidebar/notebooks/detail.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios/list',
    name: 'studios_list',
    component: () => import('../views/sidebar/studios/list.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios',
    redirect: {name: 'brains_list'},
  },
  {
    path: '/studios/new',
    name: 'studios_new',
    component: () => import('../views/sidebar/studios/new.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios/viewer/:studio_id',
    name: 'studios_viewer',
    component: () => import('../views/sidebar/studios/viewer.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios/archives',
    name: 'studios_archives',
    component: () => import('../views/sidebar/studios/archives.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios/share',
    name: 'studios_share',
    component: () => import('../views/sidebar/studios/share.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios/public',
    name: 'studios_public',
    component: () => import('../views/sidebar/studios/public.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/studios/:studio_id',
    name: 'studios_detail',
    component: () => import('../views/sidebar/studios/detail.vue'),
    meta: {requiresAuth: true},
  },
  {
    path: '/delete_account_completed',
    name: 'delete_account_completed',
    component: () => import('../views/delete_account_completed.vue'),
  },
  {
    path: '/subscription_plans',
    name: 'subscription_plans',
    component: () => import('../views/subscription_plans.vue'),
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
